var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('at-widget-booking',_vm._b({ref:"widget",attrs:{"is-admin":_vm.isAdmin ? true : false,"is-personal":_vm.isPersonal ? true : false},on:{"ready":_vm.onReady}},'at-widget-booking',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }